const $window = $(window);

/**
 * Scrolls to an element
 * @param {Object} el - The element to scroll to
 * @param {string} speed - Scroll speed
 */
const scrollToEl = (el, speed) => {
    let offsetValue = "";
    if (el === "top") {
        offsetValue = $(el).offset().top;
    } else if ($(el).length) {
        offsetValue = 0;
    }

    if (offsetValue !== "") {
        $("html, body").animate({
            "scrollTop": offsetValue
        }, speed);
    }
};

/**
 * Checks if element is in viewport
 */
$.fn.isInViewport = function () {
    const element = this.get(0);
    const bounds = element.getBoundingClientRect();
    return bounds.top < window.innerHeight && bounds.bottom > 0;
};

/**
 * Adds veil
 */
const addsVeil = () => {
    $("html").addClass("no-scroll");
};

/**
 * Removes veil
 */
const removesVeil = () => {
    $("html").removeClass("no-scroll");
};

/**
 *  Return short name of breakpoint
 *  @returns {string} - short name of current breakpoint
 */
const getsBreakpoint = () => {
    let breakpoint = "sm";

    if ($window.width() > 768) {
        breakpoint = "lg";
    } else if ($window.width() > 544) {
        breakpoint = "md";
    }

    return breakpoint;
};

/**
 *  Check if large breakpoints
 *  @returns {boolean} - current breakpoint is desktop
 */
const isLargeBreakpoint = () => {
    if ($window.width() > 768) {
        return true;
    }

    return false;
};

/**
 * Sets birthdate hidden input from options
 * @param {targetClass} - target class
 * @returns {void}
 */
const setBirthdateInputForm = (targetClass) => {
    const day = $(".birth-day").val();
    const month = $(".birth-month").val();
    const year = $(".birth-year").val();
    const birthdate = [month, day, year].join("/");
    $(targetClass).val(birthdate);
};

/**
 * create element containing CSRF token
 * @param {Object} params
 * @param {Object} params.csrf - csrf object containing token name and value.
 * @param {JQuery} params.$form - the form that the input to be added
 */
function insertCSRFTokenInput(params) {
    const $form = params.$form;
    const csrf = params.csrf;
    $form.find("#token-info").remove();
    const inputfield = document.createElement("input");
    inputfield.type = "hidden";
    inputfield.name = csrf.tokenName;
    inputfield.value = csrf.token;
    inputfield.id = "token-info";
    $form.append(inputfield);
}

/**
 * Sets csrf token to provided form
 * @param {Object} params
 * @param {Object} params.$form - the form that the input to be added
 * @returns {Promise<any>}
 */
export function setCSRFToken(params) {
    const url = $("meta[name=csrfURL]").attr("content");
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            success: function (dataToken) {
                if (params && params.$form) {
                    insertCSRFTokenInput({ csrf: dataToken.csrf, $form: params.$form });
                }
                resolve(dataToken);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
}

/**
 * @description Set top property value of the DOM element
 * @param {jquery} element - DOM element
 * @param {number}  height- height value, fallback 0
 */
export const positionTop = function (element, height=0) {
    element.css("top", height);
};

/**
 * Resize Observer for the height of the DOM element
 * @param {Function} cb - callback
 * @return {ResizeObserver}
 */
export const resizeObserver = cb => {
    return new ResizeObserver(entries => {
        for (const entry of entries) {
            if (entry.borderBoxSize) {
                const borderBoxSize = entry.borderBoxSize[0];
                const resizedHeight = borderBoxSize.blockSize;
                cb(resizedHeight);
            }
        }
    });
};

/**
* Observes an element and executes a handler when it is visible
* @param {object} $elementToObserve - jQuery element to observe
* @param {function} handler - function to execute when element is visible
* @param {object} handlerParameters - parameters to be passed to handler
* @param {object} customOptions - custom options for IntersectionObserver
* @param {number} debounceTime - debounce time for handler
*/
export const observeElementAndExecute = ($elementToObserve, handler, handlerParameters, customOptions, debounceTime) => {
    const defaultOptions = {
        root: document,
        // no extra margin for threshold
        rootMargin: "0px",
        // 0 = which means as soon as any part of the element is visible
        threshold: 0
    };
    const options = customOptions ? customOptions : defaultOptions;
    const debounce = debounceTime ? debounceTime : 0;

    if ($elementToObserve && $elementToObserve.length) {
        const observerElement = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (typeof handler === "function") {
                        const debouncedEventHandler = window.debounce(function() {
                            handler(handlerParameters);
                        }, debounce);
                        debouncedEventHandler();
                    }
                    observer.unobserve(entry.target);
                }
            });
        }, options);
        observerElement.observe($elementToObserve[0]);
    }
};

/**
* Loads more products if the last product is in view
* @param {object} customOptions - custom options for IntersectionObserver
* @param {number} debounceTime - debounce time for IntersectionObserver
*/
export const loadMoreProductsIfLastProductIsInView = (customOptions, debounceTime) => {
    const pageSize = parseFloat($(".grid-footer").data("page-size"));
    const pageNumber = parseFloat($(".grid-footer").data("page-number") + 1);
    const lastIndex = (pageSize * pageNumber).toFixed(1);
    const $lastProduct = $(".product-tile-order[data-value='" + lastIndex + "']").last();
    const handler = () => {
        const $showMoreBtn = $(".show-more button");
        $showMoreBtn.click();
    };
    const debounce = debounceTime ? debounceTime : 500;

    observeElementAndExecute($lastProduct, handler, null, customOptions, debounce);
};

/**
* Aborts all ajax requests if the footer is in view
* @param {object} handlerParameters - Parameters for the handler function
* @param {object} customOptions - Options for IntersectionObserver
* @param {number} debounceTime - Time to debounce the handler
*/
export const abortIfFooterIsInView = (handlerParameters, customOptions, debounceTime) => {
    const $footer = $("#footercontent");
    const handler = (handlerParameters) => {
        $.each(handlerParameters, (index, $ajaxRequest) => $ajaxRequest.abort());
    };

    observeElementAndExecute($footer, handler, handlerParameters, customOptions, debounceTime);
};

/**
* Filters out previous AJAX calls that have a status of 200 or 0
* @param {object} ajaxRequestList - list of AJAX requests
* @returns {object} - list of AJAX requests with status not equal to 200 or 0
*/
export const cleanUpPreviousCalls = (ajaxRequestList) => {
    return ajaxRequestList.filter($ajaxRequest => ![200, 0].includes($ajaxRequest.status));
};

/**
* Show or hide the loading text
* @param {boolean} isShow - whether to show the loading text
*/
export const setLoadingTextVisibility = (isShow) => {
    const $loadingText = $(".show-more-loading");

    isShow ? $loadingText.removeClass("d-none") : $loadingText.addClass("d-none");
};

/**
* Updates the query string parameter of a given URI
* @param {string} uri - the target URI
* @param {string} key - the query string parameter to update
* @param {string} value - the new value for the parameter
* @returns {string} - the updated URI
*/
export const updateQueryStringParameter = (uri, key, value) => {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    }
    return uri + separator + key + "=" + value;
};

/**
* The function updates the query string of the current URL with a new key-value pair and updates the browser history.
* @param {string} key - The key is a string representing the name of the query parameter that needs to be updated in the URL.
* @param {string} value - The value parameter is the new value that you want to set for the specified key in the URL query string.
* @param {boolean} isRemoveKey - whether to remove the key from the query string
*/
export const updateQueryString = (key, value, isRemoveKey) => {
    if (history.pushState) {
        let searchParams = new URLSearchParams(window.location.search);

        isRemoveKey ? searchParams.delete(key) : searchParams.set(key, value);
        searchParams.sort();
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + searchParams.toString();
        window.history.pushState({path: newurl}, "", newurl);
    }
};

/**
* Updates the label of a combobox element
* @param {object} $selectEl - jQuery element of the select element
*/
export const updateLabelByComboBox = ($selectEl) => {
    if ($selectEl && $selectEl.length) {
        const labelId = $selectEl.siblings("label").attr("id");

        if (labelId) {
            $selectEl.siblings(".select2-container").find("[role=combobox]").attr("aria-labelledby", labelId);
        }
    }
};

export const scrollTo = scrollToEl;
export const isInViewport = $.fn.isInViewport;
export const addVeil = addsVeil;
export const removeVeil = removesVeil;
export const getBreakpoint = getsBreakpoint;
export const isDesktop = isLargeBreakpoint;
export const setBirthdateInput = setBirthdateInputForm;
